export const SET_CONFIGS = 'SET_CONFIGS';
export const SET_ORDER_TIMERS = 'SET_ORDER_TIMERS';
export const SET_COUNTRIES = 'SET_COUNTRIES';
export const SET_REGIONS = 'SET_REGIONS';
export const SET_DISTRICTS = 'SET_DISTRICTS';
export const SET_CEMETERIES = 'SET_CEMETERIES';
export const SET_WORKING_REGIONS = 'SET_WORKING_REGIONS';
export const UPDATE_WORKING_REGION = 'UPDATE_WORKING_REGION';
export const SET_ADMINS = 'SET_ADMINS';
export const UPDATE_ADMIN_PERMISSION = 'UPDATE_ADMIN_PERMISSION';
export const SET_INDIVIDUAL_REGIONS = 'SET_INDIVIDUAL_REGIONS';
